import { GetFormattedDate } from "../../../../../services/helpers";

export const mapTemplateToFormData = (template) => {
  return {
		selectedType: template.objectType,
		brand: template.brand?.id || 0,
		validFrom: GetFormattedDate(template.validFrom),
		validTill: GetFormattedDate(template.validTill),
		operationCode: template.operationCode ?? '',
		description: template.description,
		isAutosuggest: template.isAutoSuggest,
		isActive: template.isActive,
		isB2CExcluded: template.isB2CExcluded,
		isMandatory: template.isMandatory,
		signatureOutletUserRoleID1: template.signatureOutletUserRoleID1 || 0,
		signatureOutletUserRoleID2: template.signatureOutletUserRoleID2 || 0,
		modified: {
			byLastName: template.modifiedByLastName,
			byFirstName: template.modifiedByFirstName,
			on: template.modifiedOn,
			avatar: template.modifiedByAvatar,
		},
    created:{
      byLastName: template.createdByLastName,
			byFirstName: template.createdByFirstName,
			on: template.createdOn,
			avatar: template.createdByAvatar,
    }
	};
};

export const mapSegmentsToDnD = (segments) => {
  const dndItems = {};
  const dndSegmentMetadata = {};

  segments.forEach((segment) => {
    const containerId = `container_${segment.id}`;

    dndItems[containerId] = segment.items.map((item) => item.id);

    dndSegmentMetadata[containerId] = {
      description: segment.description,
      isActive: segment.isActive,
      items: segment.items.reduce((itemAcc, item) => {
        itemAcc[item.id] = {
          longDescription: item.description,
          shortDescription: item.shortDescription,
          responseType: item.responseType,
          isActive: item.isActive,
        };
        return itemAcc;
      }, {}),
    };
  });

  return { dndItems, dndSegmentMetadata };
};
